import { Screen } from '~/screens/groups/edit';

export const GroupsEdit: React.FC = () => <Screen />;
